import { render, staticRenderFns } from "./AddNewBlog.vue?vue&type=template&id=776ea518&"
import script from "./AddNewBlog.vue?vue&type=script&lang=js&"
export * from "./AddNewBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports